"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formRules = exports.defaultFormData = void 0;
var defaultFormData = exports.defaultFormData = {
  adName: '',
  // 广告名称
  adImage: '',
  // 广告图片
  jumpUrl: '',
  // 跳转链接
  isEnabled: false // 是否启用
};
var formRules = exports.formRules = {
  adName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入广告名称'
  }],
  adImage: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择广告图片'
  }],
  jumpUrl: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入跳转链接'
  }]
};